import { Provider } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { provideNgxMask } from 'ngx-mask';
import { CloseScrollStrategy, Overlay } from '@angular/cdk/overlay';
import {
  MatBottomSheetConfig,
  MAT_BOTTOM_SHEET_DEFAULT_OPTIONS,
} from '@angular/material/bottom-sheet';
import {
  MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
  MatButtonToggleDefaultOptions,
} from '@angular/material/button-toggle';
import { MatDialogConfig, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import {
  MatFormFieldDefaultOptions,
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
} from '@angular/material/form-field';
import { MAT_TOOLTIP_SCROLL_STRATEGY } from '@angular/material/tooltip';
import { MatSnackBarConfig, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import {
  MatProgressSpinnerDefaultOptions,
  MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS,
} from '@angular/material/progress-spinner';

const SNACKBAR_DEFAULT_CONFIG: MatSnackBarConfig = {
  horizontalPosition: 'center',
  verticalPosition: 'top',
};

const BOTTOM_SHEET_DEFAULT_CONFIG: MatBottomSheetConfig = {
  autoFocus: false,
  closeOnNavigation: true,
  restoreFocus: false,
};

const PROGRESS_SPINNER_DEFAULT_CONFIG: MatProgressSpinnerDefaultOptions = {
  diameter: 60,
  strokeWidth: 3,
};

const DIALOG_DEFAULT_CONFIG: MatDialogConfig = {
  closeOnNavigation: true,
  hasBackdrop: true,
  autoFocus: false,
  restoreFocus: false,
  width: '90vw',
  maxWidth: '425px',
};

const FORM_FIELD_DEFAULT_CONFIG: MatFormFieldDefaultOptions = {
  appearance: 'outline',
  subscriptSizing: 'dynamic',
};

const MAT_BUTTON_TOGGLE_DEFAULT_CONFIG: MatButtonToggleDefaultOptions = {
  hideSingleSelectionIndicator: true,
  hideMultipleSelectionIndicator: true,
};

function tooltipScrollFactory(overlay: Overlay): () => CloseScrollStrategy {
  return () => overlay.scrollStrategies.close();
}

// App-wide Material defaults and helpers formerly provided by SharedModule (which the root
// injector got through CoreModule > InterceptorsModule > DialogModule, and every lazy feature
// module re-provided with the same values)
export function provideSharedDefaults(): Provider[] {
  return [
    { provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS, useValue: MAT_BUTTON_TOGGLE_DEFAULT_CONFIG },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: SNACKBAR_DEFAULT_CONFIG },
    { provide: MAT_BOTTOM_SHEET_DEFAULT_OPTIONS, useValue: BOTTOM_SHEET_DEFAULT_CONFIG },
    { provide: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS, useValue: PROGRESS_SPINNER_DEFAULT_CONFIG },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: FORM_FIELD_DEFAULT_CONFIG,
    },
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: DIALOG_DEFAULT_CONFIG },
    {
      provide: MAT_TOOLTIP_SCROLL_STRATEGY,
      useFactory: tooltipScrollFactory,
      deps: [Overlay],
    },
    DatePipe,
    provideNgxMask(),
    // Formerly provided by DecimalInputModule (re-exported by SharedModule); DecimalInputDirective injects it
    DecimalPipe,
  ];
}
